import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-vp_play",
  "use": "n-icon-vp_play-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"n-icon-vp_play\">\n<path d=\"M22.0887 13.6537C23.1149 14.258 23.1149 15.7422 22.0887 16.3465L11.1054 22.8146C10.0638 23.428 8.75 22.677 8.75 21.4682V8.53204C8.75 7.32323 10.0638 6.57225 11.1054 7.18565L22.0887 13.6537Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol